<app-view-state-container class="height100p flex-col" [state]="viewState">
    <ng-template #content>
        <div class="height100p flex-col">
        @if (nothingFound) {
        <div class="grid flex-item-fixed">
            <p-card header="Keine Kompetenzen gefunden">
            Es wurden keine Kompetenzen in enaio gefunden.
            </p-card>
        </div>
        }
        
        @if (editingAllowed === false) {
        <div class="grid flex-item-fixed">
            <p-card class="col-12" header="Bearbeitung nicht freigegeben">
            <span style="color: red">Die Bearbeitung der Zeugnisse wurde durch den Administrator noch nicht freigegeben.</span>
            </p-card>
        </div>
        }
        
        @if (loaded) {
        <div class="grid flex-item-fixed">
            <sm-toolbar class="col-12">
            @if (!isGradeCertificate) {
                <p-select class="width300" id="domain" [options]="domains"
                [(ngModel)]="selectedDomain" (onChange)="selectedDomainChanged()">
                </p-select>
            }
            <p-button icon="fas fa-eye" label="Vorschau" (onClick)="preview()" [disabled]="!editingAllowed">
            </p-button>
            <p-button icon="fas fa-cloud-upload-alt" label="Zeugnis erstellen" (onClick)="saveDocument()"></p-button>
            <p-button icon="fas fa-save" label="Speichern" (onClick)="saveClick(0)" [disabled]="!editingAllowed">
            </p-button>
            <p-button icon="fas fa-arrow-left" label="Speichern & Vorheriger Schüler" (onClick)="saveClick(-1)" [disabled]="!editingAllowed">
            </p-button>
            <p-button icon="fas fa-arrow-right" label="Speichern & Nächster Schüler" (onClick)="saveClick(1)" [disabled]="!editingAllowed">
            </p-button>
            @if (lastYearCertId > 0) {
                <p-button icon="fas fa-redo" label="Kompetenzauswahl aus Vorjahr übernehmen" (onClick)="copyFromLastYear()">
                </p-button>
            }
            @if (isAdmin) {
                <p-button severity="warn" icon="fas fa-redo" label="Kompetenzen neu generieren" (onClick)="refresh()">
                </p-button>
            }
            @if (pupil.getSchoolType() === _SchoolType.special) {
                <p-checkbox class="ml-3" appLabel="Alle Kompetenzen selektieren" [ngModel]="getAllMarksVisible()" [indeterminate]="getAllMarksVisible() === null" (onChange)="allMarksVisibilityChanged($event)" [binary]=true [disabled]="!editingAllowed"></p-checkbox>
            }
            </sm-toolbar>
        </div>
        }
        <div class="grid flex-item-fill overflow-y-auto" [appDisable]="!editingAllowed">
        @if (gradeBookSchoolClass != null) {
            <p-table class="width50p center-x mb-3 p-datatable-gridlines" [value]="grades">
            <ng-template pTemplate="header">
                <tr>
                <th>Fach</th>
                <th>&Oslash;</th>
                <th>Endnote</th>
                <th>letzte Bearbeitung</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-grade>
                @if (grade.firstOfGroup) {
                <tr>
                    <td colspan="4"><b>{{grade.group}}</b></td>
                </tr>
                }
                <tr>
                <td>{{grade.label}}</td>
                <td>{{grade.average}}</td>
                <td pEditableColumn>
                    <p-cellEditor>
                    <ng-template pTemplate="input">
                        <p-select class="width100p" id="certificateGrade" [editable]=false [options]="certificateGradeItems" [(ngModel)]="grade.o.grade">
                        </p-select>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{grade.o.grade}}
                    </ng-template>
                    </p-cellEditor>
                </td>
                <td>{{grade.o.getModifiedText()}}</td>
                </tr>
            </ng-template>
            </p-table>
        }
        @if (isForFinalExam) {
            <div class="grid col-12" style="margin-top:20px">
                <div class="width50p center-x mb-3">
                    <label class="labelx" for="finalExamGrade">Gesamtprädikat:</label>
                    <input class="ml-2" style="width: 300px" id="finalExamGrade" type="number" pInputText
                        [(ngModel)]="guiCertificate.finalExamGrade" />
                </div>
            </div>
        }
        @if (loaded) {
            <p-card header="{{selectedDomain}}" class="col-12">
            <p-table class="p-datatable-gridlines" *ngVar="guiCertificate.domains.get(selectedDomain) as sel" [value]="sel.marksFlat">
                <ng-container *ngVar="sel.showTrend(pupil) as sr">
                <ng-template pTemplate="header">
                    <tr>
                    @if (sel.hasLevel2) {
                        <th width="12%" [attr.rowspan]="sr ? 2 : 1">Kompetenzstufe 1</th>
                    }
                    @if (sel.hasLevel2) {
                        <th width="13%" [attr.rowspan]="sr ? 2 : 1">Kompetenzstufe 2</th>
                    }
                    <th width="23%" [attr.rowspan]="sr ? 2 : 1">Grundkompetenz</th>
                    <th width="5%" [attr.rowspan]="sr ? 2 : 1">nicht be&shy;wer&shy;tet</th>
                    <th width="5%" [attr.rowspan]="sr ? 2 : 1">nicht be&shy;urteil&shy;bar</th>
                    @for (markName of markNames; track markName; let index = $index) {
                        <th width="5%" min-width="50px" [attr.rowspan]="sr ? 2 : 1" [innerHTML]="markName | keepHtml"></th>
                    }
                    @if (sel.domain != 'Kompetenzentwicklung') { 
                        <th width="20%" [attr.rowspan]="sr ? 2 : 1">
                        {{!sr ? 'Bemerkungen' : 'Bemerkungen / sonderpäd. Maßnahmen'}}
                        </th>
                    }
                    <th width="15%" [attr.rowspan]="sr ? 2 : 1">letzte Bearbeitung</th>
                    @if (sr) {
                        <th width="15%" [attr.colspan]="5">Lernentwicklung</th>
                    }
                    </tr>
                    @if (sr) {
                    <tr>
                        <th width="3%">-</th>
                        <th width="3%">&#x2B07;</th>
                        <th width="3%">&#x2198;</th>
                        <th width="3%">&#x2197;</th>
                        <th width="3%">&#x2B06;</th>
                    </tr>
                    }
                </ng-template>
                <ng-template pTemplate="body" let-mark>
                    
                    @if (mark.level1Span > 0 && !sel.hasLevel2) {
                    <tr>
                        <td [attr.colspan]="5 + markNames.length + (sr ? 5 : 0)" style="background-color: #FABF8E">@if (pupil.getSchoolType() === _SchoolType.special) {
                        <p-checkbox [style.margin-right.px]="10" [ngModel]="getLevel1Hidden(mark)" (onChange)="level1VisibilityChanged($event, mark)" binary="true" [indeterminate]=true></p-checkbox>
                        }{{mark.level1}}
                        </td>
                    </tr>
                    }
                    <tr>
                    @if (mark.level1Span > 0 && sel.hasLevel2) {
                        <td [attr.rowspan]="mark.level1Span"
                        [style.background-color]="'#FABF8E'">@if (pupil.getSchoolType() === _SchoolType.special) {
                        <p-checkbox [style.margin-right.px]="10" [ngModel]="getLevel1Hidden(mark) === true" [indeterminate]="getLevel1Hidden(mark) === null" (onChange)="level1VisibilityChanged($event, mark)" binary="true"></p-checkbox>
                        }{{mark.level1}}</td>
                    }
                    @if (mark.level2Span > 0 && sel.hasLevel2) {
                        <td [attr.rowspan]="mark.level2Span"
                        [style.background-color]="'#ffffff'">@if (pupil.getSchoolType() === _SchoolType.special) {
                        <p-checkbox [style.margin-right.px]="10" [ngModel]="getLevel2Hidden(mark) === true" [indeterminate]="getLevel2Hidden(mark) === null" (onChange)="level2VisibilityChanged($event, mark)" binary="true"></p-checkbox>
                        }{{mark.level2}}</td>
                    }
                    <td> @if (pupil.getSchoolType() === _SchoolType.special) {
                        <p-checkbox [style.margin-right.px]="10" [ngModel]="!mark.hidden" (onChange)="markVisibilityChanged($event, mark)" [binary]=true></p-checkbox>
                        }{{mark.title}}
                    </td>
                    <td>
                        <!-- p-radiobutton mit massiven Performanceproblemen bei der Menge an Inputs-->
                        <input type="radio" class="p-radiobutton" [name]="mark.competencyId + '_mark'" [value]="0" [(ngModel)]="mark.mark" (ngModelChange)="somethingChanged()"/>
                    </td>
                    <td>
                        <input type="radio" class="p-radiobutton" [name]="mark.competencyId + '_mark'" [value]="99" [(ngModel)]="mark.mark" (ngModelChange)="somethingChanged()"/>
                    </td>
                    @for (markName of markNames; track markName; let index = $index) {
                        <td>
                        <input type="radio" class="p-radiobutton" [name]="mark.competencyId + '_mark'" [value]="index + 1" [(ngModel)]="mark.mark" (ngModelChange)="somethingChanged()"/>
                        </td>
                    }
                    @if (sel.domain != 'Kompetenzentwicklung') {
                        <td  pEditableColumn>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                            <textarea pTextarea class="width100p height100p" spellcheck=true type="text" autoResize="autoResize"
                            [(ngModel)]="mark.note" (ngModelChange)="somethingChanged()"></textarea>
                            </ng-template>
                            <ng-template pTemplate="output">
                            {{mark.note}}
                            </ng-template>
                        </p-cellEditor>
                        </td>
                    }
                    <td>{{mark.assignedBy}}
                    {{mark.assignedDate != null ? (mark.assignedDate | date: 'dd.MM.yy HH:mm') : ''}}</td>
                    @if (sr) {
                        <td>
                        <input type="radio" class="p-radiobutton" [name]="mark.competencyId + '_trend'" [value]="0" (ngModelChange)="somethingChanged()"
                            [(ngModel)]="mark.trend"/>
                        </td>
                    }
                    @if (sr) {
                        <td>
                        <input type="radio" class="p-radiobutton" [name]="mark.competencyId + '_trend'" [value]="1" (ngModelChange)="somethingChanged()"
                            [(ngModel)]="mark.trend"/>
                        </td>
                    }
                    @if (sr) {
                        <td>
                        <input type="radio" class="p-radiobutton" [name]="mark.competencyId + '_trend'" [value]="2" (ngModelChange)="somethingChanged()"
                            [(ngModel)]="mark.trend"/>
                        </td>
                    }
                    @if (sr) {
                        <td>
                        <input type="radio" class="p-radiobutton" [name]="mark.competencyId + '_trend'" [value]="3" (ngModelChange)="somethingChanged()"
                            [(ngModel)]="mark.trend"/>
                        </td>
                    }
                    @if (sr) {
                        <td>
                        <input type="radio" class="p-radiobutton" [name]="mark.competencyId + '_trend'" [value]="4" (ngModelChange)="somethingChanged()"
                            [(ngModel)]="mark.trend"/>
                        </td>
                    }
                    </tr>
                </ng-template>
                </ng-container>
            </p-table>
            @if (guiCertificate.domains.get(selectedDomain).averageGrade >= 0) {
                <div class="grid" style="margin-top:20px">
                <label class="labelx" for="teacher">Durchschnittsnote aus Notenbuch:</label>
                <input class="ml-2" style="width: 300px" id="teacher" type="text" pInputText [disabled]=true
                    [(ngModel)]="guiCertificate.domains.get(selectedDomain).averageGrade" />
                </div>
                }
                <div class="grid" style="margin-top:20px">
                <label class="labelx" for="teacher">Bewertung durch Fachlehrer:</label>
                @if (!addTeacherNameForDomains.includes(selectedDomain)) {
                    <input class="ml-2" style="width: 300px" id="teacher" type="text" pInputText
                    [(ngModel)]="guiCertificate.domains.get(selectedDomain).teacher" />
                }
                @if (addTeacherNameForDomains.includes(selectedDomain)) {
                    <input class="ml-2" style="width: 300px" id="teacher" type="text" pInputText readonly [value]="getThisTeacherName()"/>
                    <p-message class="ml-3" severity="info">(Automatisch gesetzt aufgrund vorgenommener Änderungen)</p-message>
                }
                </div>
                <div class="grid" style="margin-top:20px">
                <label class="labelx" for="topics">Bemerkungen:</label>
                <textarea pTextarea spellcheck=true class="ml-2" style="width: 800px; height: 200px" id="topics" type="text"
                [rows]="5" [(ngModel)]="guiCertificate.domains.get(selectedDomain).topics"></textarea>
                </div>
            </p-card>
            }
        </div>
        </div>
    </ng-template>
</app-view-state-container>
